import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import usePaymentConditionService from '../../../app/services/hooks/usePaymentConditionService';

interface Props {
    paymentConditionId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const PaymentConditionSwitchChange = ({
    paymentConditionId,
    checkValue,
    callbackSuccess
}: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { activePaymentCondition, fetchingActivePaymentCondition } =
        usePaymentConditionService();

    const active = (value: boolean) => {
        setChecked(value);
        activePaymentCondition(paymentConditionId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={paymentConditionId} callback={active} />;
};

export default PaymentConditionSwitchChange;
